// Professional Quick Actions Component
import React from 'react';
import { Link } from 'react-router-dom';
import { COLORS, LAYOUT } from '../../constants';

const QuickActions = () => {
  const quickActions = [
    {
      title: 'Add New Listing',
      description: 'Post a new item for sale and reach fellow Redbirds',
      icon: (
        <svg fill="currentColor" viewBox="0 0 24 24">
          <path d="M19,13H13V19H11V13H5V11H11V5H13V11H19V13Z"/>
        </svg>
      ),
      link: '/add-listing',
      bgColor: COLORS.primary,
    },
    {
      title: 'My Listings',
      description: 'Manage and edit your active listings',
      icon: (
        <svg fill="currentColor" viewBox="0 0 24 24">
          <path d="M9,5V9H21V7H11V5H9M9,19H21V17H9V19M9,14H21V12H9V14M4,9H8L6,11L8,13H4V9M4,19H8V17H4V19M4,12H8V14H4V12Z"/>
        </svg>
      ),
      link: '/my-listings',
      bgColor: COLORS.primary,
    },
    {
      title: 'Messages',
      description: 'Chat with buyers and manage inquiries',
      icon: (
        <svg fill="currentColor" viewBox="0 0 24 24">
          <path d="M20,2H4C2.9,2 2,2.9 2,4V22L6,18H20C21.1,18 22,17.1 22,16V4C22,2.9 21.1,2 20,2M20,16H5.2L4,17.2V4H20V16M7,9H17V11H7V9M7,12H15V14H7V12M7,6H17V8H7V6Z"/>
        </svg>
      ),
      link: '/direct',
      bgColor: COLORS.primary,
    },
    {
      title: 'Analytics',
      description: 'View sales performance and insights',
      icon: (
        <svg fill="currentColor" viewBox="0 0 24 24">
          <path d="M16,6L18.29,8.29L13.41,13.17L9.41,9.17L2,16.59L3.41,18L9.41,12L13.41,16L19.71,9.71L22,12V6H16Z"/>
        </svg>
      ),
      link: '/transactions',
      bgColor: COLORS.primary,
    }
  ];

  return (
    <div style={modernStyles.section}>
      <div style={modernStyles.sectionHeader}>
        <h3 style={modernStyles.sectionTitle}>Quick Actions</h3>
        <p style={modernStyles.sectionSubtitle}>
          Manage your store efficiently
        </p>
      </div>
      
      <div style={modernStyles.actionsList}>
        {quickActions.map((action, index) => (
          <Link 
            key={index}
            to={action.link} 
            style={modernStyles.actionItem}
            className="quick-actions-item"
          >
            <div style={{
              ...modernStyles.actionIcon,
              backgroundColor: `${action.bgColor}15`,
              color: action.bgColor,
            }}>
              {action.icon}
            </div>
            
            <div style={modernStyles.actionContent}>
              <div style={modernStyles.actionTitle}>{action.title}</div>
              <div style={modernStyles.actionDescription}>{action.description}</div>
            </div>
            
            <div style={modernStyles.actionArrow} className="action-arrow">
              <svg fill="currentColor" viewBox="0 0 24 24">
                <path d="M8.59,16.58L13.17,12L8.59,7.41L10,6L16,12L10,18L8.59,16.58Z"/>
              </svg>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
};

const modernStyles = {
  section: {
    backgroundColor: COLORS.white,
    borderRadius: LAYOUT.borderRadius.xl,
    padding: LAYOUT.spacing.xl,
    border: `1px solid ${COLORS.border}`,
    boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
  },
  
  sectionHeader: {
    marginBottom: LAYOUT.spacing.lg,
  },
  
  sectionTitle: {
    fontSize: '1.3rem',
    fontWeight: '700',
    color: COLORS.text.primary,
    marginBottom: '2px',
  },
  
  sectionSubtitle: {
    fontSize: '0.85rem',
    color: COLORS.text.secondary,
    lineHeight: '1.4',
  },
  
  actionsList: {
    display: 'flex',
    flexDirection: 'column',
    gap: '2px',
  },
  
  actionItem: {
    display: 'flex',
    alignItems: 'center',
    gap: LAYOUT.spacing.md,
    padding: LAYOUT.spacing.md,
    textDecoration: 'none',
    borderRadius: LAYOUT.borderRadius.lg,
    transition: 'all 0.2s ease',
    color: 'inherit',
  },
  
  actionIcon: {
    width: '36px',
    height: '36px',
    borderRadius: LAYOUT.borderRadius.lg,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
  },
  
  actionContent: {
    flex: 1,
    minWidth: 0,
  },
  
  actionTitle: {
    fontSize: '0.95rem',
    fontWeight: '600',
    color: COLORS.text.primary,
    marginBottom: '2px',
    lineHeight: '1.3',
  },
  
  actionDescription: {
    fontSize: '0.8rem',
    color: COLORS.text.secondary,
    lineHeight: '1.3',
  },
  
  actionArrow: {
    width: '16px',
    height: '16px',
    color: COLORS.text.muted,
    flexShrink: 0,
    transition: 'all 0.2s ease',
  },
};

// Add hover styles for quick actions
const quickActionStyles = `
  .quick-actions-item:hover {
    background-color: ${COLORS.grayLight} !important;
  }
  
  .quick-actions-item:hover .action-arrow {
    color: ${COLORS.primary} !important;
    transform: translateX(2px) !important;
  }
`;

// Inject styles
if (typeof document !== 'undefined') {
  const styleElement = document.getElementById('quick-actions-styles');
  if (!styleElement) {
    const style = document.createElement('style');
    style.id = 'quick-actions-styles';
    style.textContent = quickActionStyles;
    document.head.appendChild(style);
  }
}

export default QuickActions;